module.exports = {
    CLICK: 'click',
    EMPTY: '',
    ENTER: 'Enter',
    SELECTED: 'selected'
}